$ = require('jquery')

exports.init = (options) ->
	realclick = true

	$(document)
		.on('click', '.js-tab-links', (event) ->
			event.preventDefault()

			# variables
			$link = $(this)
			return if $link.is('.is-active') or $link.is('.is-disabled')

			id = $link.attr('href')

			$tab = $(id)
			$tabsWrap = $tab.closest('.box-tabs')
			$otherLinks = $tabsWrap.find('.js-tab-links')
			$tabsOther = $tab.siblings('.box-tabs__fragment')

			# classes
			$tab.addClass('is-active')
			$tabsOther.removeClass('is-active')

			$otherLinks.removeClass('is-active')
			$link.addClass('is-active')

			# history
			if $tabsWrap.hasClass('with-history') and realclick
				history.pushState(null, null, id);

			# ajax
			if $link.hasClass('is-ajax') and not $link.data('ajaxed')
				$.ajax(
					url: $link.data('ajax')
				)
				.done( (response) ->
					$tab.find('.box-tabs__content').html(response)
					$link.data('ajaxed', true)
				)
		)
		.on('click', '.box-tabs__responsive-link', (event) ->
			event.preventDefault()

			# variables
			$this = $(@)
			$tabsWrap = $this.closest('.box-tabs')
			$tab = $this.closest('.box-tabs__fragment')
			$links = $tabsWrap.find('.js-tab-links')
			$target = $links.filter('[href="#' + $tab.attr('id') + '"]')

			if $target.hasClass('is-active')
				$target.add($tab).removeClass('is-active')
			else
				$target.trigger('click')
				if $tab.offset().top < $(window).scrollTop()
					$('body, html').animate(
						scrollTop: $tab.offset().top
					250)
		)

	# hash change
	$(window).on('hashchange', ->
		id = ''
		realclick = false

		if location.hash != ''
			$('.box-tabs .js-tab-links[href=' + location.hash + ']').click();
		else
			$('.box-tabs .box-tabs__menu__item:first-child .js-tab-links').click()

		realclick = true
	).trigger('hashchange')

	$('.box-tabs').each(->
		if $(@).hasClass('mobile-hide') && $(window).width() < 700
			$(@).find('.is-active').removeClass('is-active')
	)



/** WEBPACK FOOTER **
 ** ./src/js/components/tabs.coffee
 **/